<script setup>
import BaseModal from "@/components/global-themed/BaseModal.vue";
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";

const emit = defineEmits(['close', 'confirm']);
</script>

<template>
  <BaseModal
    modal-class="tw-max-w-[800px]"
    @close="emit('close')"
  >
    <div class="tw-px-8 tw-pb-8 tw-flex tw-flex-col tw-gap-8 tw-justify-center tw-text-left">
      <h2 class="tw-text-2.5xl tw-text-grey-dark tw-font-bold">
        Before You Start Your SEO With the Onsite Optimizer
      </h2>

      <div class="tw-flex tw-flex-col tw-gap-4 tw-text-font-secondary tw-text-base">
        <div>
          Please be aware that any SEO changes made through the Onsite Optimizer will not remain active if a website is removed from your account via Vendasta.
        </div>
        <div>
          This means that all implemented SEO enhancements will be reverted once the website is no longer managed through the platform.
        </div>

        <div>
          Please acknowledge you understand this by clicking ""Confirm"" below."
        </div>
      </div>

      <div class="tw-flex tw-w-full tw-justify-center">
        <DefaultButton
          @click="emit('confirm')"
        >
          Confirm
        </DefaultButton>
      </div>
    </div>
  </BaseModal>
</template>
